<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <label class="generalLabel" for="vendorCheck">Se va a denegar la revisión del contrato, pulse "Confirmar" para
      continuar.</label>
    <button class="btn btn-primary generalPrimaryButton float-right" data-dismiss="modal" aria-label="Close"
      @click="deny()">Confirmar</button>
  </Modal>
</template>

<script>

import Modal from '../../../Shared/Modal.vue';
import axios from 'axios';
export default {
  name: 'DenyContract',
  props: [
    'id',
    'modalTitle',
    'class',
    'contractId',
    'business',
    'contractIndex'
  ],
  data() {
    return {
      classes: this.class,
    }
  },
  components: {
    Modal,
  },
  methods: {
    deny() {
      if (this.business) {
        let bodyToSend = {
          businessContractId: this.contractId,
          status: 'REJECTED',
        }
        axios.patch(`/business/update-contract`, bodyToSend)
          .then(() => {
            let bodyStatus = {
              "contractIndex": this.contractIndex,
              "cancellation": bodyToSend.status,
              "description": 'BUSINESS RECHAZADA'
            }
            this.$emit("refreshContractList", bodyStatus);
          });
      } else {
        let bodyToSend = {
          contractId: this.contractId,
          status: 'DENIED',
          blacklist: false
        }
        axios.put(`/contract/validation/update-status`, bodyToSend)
          .then(() => {
            let bodyStatus = {
              "contractIndex": this.contractIndex,
              "cancellation": bodyToSend.status,
              "description": 'DENEGADO'
            }
            this.$emit("refreshContractList", bodyStatus);
          });
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
